import { Helmet } from "react-helmet"
import MasterGamesList from "../data/MasterGamesList"
import ProvidersData from "../data/ProvidersData"
export const currentPath = window.location.pathname
export const currentDomain = window.location.origin

function SlotsGames() {
  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Slots - FGH - Your One-Stop Gaming Site</title>
        <link rel="icon" href="/images/fav.webp" sizes="32x32" />
        <meta
          name="description"
          content="Play top-rated online slots at FGH Casino PH. Fast wins, easy GCash/Maya deposits & cashouts. Safe play for Filipino players 21+."
        />
        <link rel="canonical" href={`${currentDomain}${currentPath}`} />
      </Helmet>
      {/* <div className="testchat"><LiveChatWidget license="11142882" visibility="minimized" /></div> */}
      <section className="main-body-content main-container-global-adjusted-padding">
        <div className="fgh-slot-games-page-main">
          <div className="fgh-section-margin fgh-home-provider-games">
            <ProvidersData />
          </div>
          <div className="fgh-heading-container">
            <h1 className="fgh-h1-style normal-margin-bottom">
              Best Online Slot Games in Asia
            </h1>
            <br />

            <label className="fgh-normal-label-style standard-margin-bottom">
              (JILI, Pragmatic Play, RTG, Fachai & More)
            </label>
          </div>
          <div className="fgh-slots-games">
            <MasterGamesList
              limit={60}
              tools="on"
              recentgames="showall"
              headerText="Top Games you can play"
              headerTag="h2"
            />
          </div>
          <div className="fgh-section-margin fgh-section-articles">
            <div className="fgh-main-page-content">
              <div className="fgh-left-char">
                <img src="/images/character/FGH-CHARACTER_3.webp" alt="" />
              </div>
              <div className="fgh-right-cont">
                <h2 className="fgh-h2-style standard-margin-bottom">
                  Spin, Win, and Ignite the Reels at FGH!
                </h2>
                <p className="fgh-paragraph-standard-style">
                  Step into the ultimate slot paradise at FGH! We've lined up
                  the hottest games featuring vibrant themes, explosive
                  features, and massive multipliers.
                </p>
                <p className="fgh-paragraph-standard-style">
                  Whether you're chasing life-changing jackpots or just spinning
                  for fun, every round is packed with potential. Just tap, spin,
                  and let the good times roll!
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default SlotsGames
